import styled from '@emotion/styled'
import { textMixin } from '../../../mixins/TextMixin/TextMixin'
import { getComponentTheme } from '../../../__styling'
import { CardContainer } from '../components/CardContainer'

export const Headline = styled.div(({ theme }) => {
    const headlineTheme = getComponentTheme(theme, 'articleCard')
    return [
        {
            width: '100%',
        },
        textMixin(theme, headlineTheme.heading.textType),
    ]
})

export const ArticleCardContainer = styled(CardContainer)({
    // Underline Headline when hovered or active.
    [`&:is(:hover, :focus) ${Headline}`]: {
        textDecoration: 'underline',
    },
})
